<template>
	<el-dialog v-dialogDrag title="添加好友" :visible.sync="dialogVisible" width="400px" :before-close="onClose"
		custom-class="add-friend">
		<el-input placeholder="输入完整用户ID(如NB123456)或完整用户名搜索,不支持模糊搜索" class="input-with-select" v-model="searchText" size="small"
			@keyup.enter.native="onSearch()">
			<i class="el-icon-search el-input__icon" slot="suffix" @click="onSearch()"> </i>
		</el-input>
		<el-scrollbar style="height:400px">
			<div v-if="searched && !users.length" class="empty-tip">未找到该用户，请确认完整ID或用户名是否正确</div>
			<div v-for="(user) in users" :key="user.id" v-show="user.id != userStore.userInfo.id">
				<div class="item">
					<div class="avatar">
						<head-image :name="user.nickName" :url="user.headImage" :online="user.online"></head-image>
					</div>
					<div class="friend-info">
						<div class="nick-name">
							<div>{{ user.nickName }}</div>
							<div :class="user.online ? 'online-status  online' : 'online-status'">{{
								user.online ? "[在线]" : "[离线]" }}</div>
						</div>
						<div class="user-name">
							<div v-if="user.uid">ID:{{ user.uid }}</div>
							<div>用户名:{{ user.userName }}</div>
						</div>
					</div>
					<el-button type="primary" size="mini" v-show="!isFriend(user.id)"
						@click="onAddFriend(user)">添加</el-button>
					<el-button type="info" size="mini" v-show="isFriend(user.id)" plain disabled>已添加</el-button>
				</div>
			</div>
		</el-scrollbar>
	</el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue'


export default {
	name: "addFriend",
	components: { HeadImage },
	data() {
		return {
			users: [],
			searched: false,
			searchText: ""
		}
	},
	props: {
		dialogVisible: {
			type: Boolean
		}
	},
	methods: {
		onClose() {
			this.$emit("close");
		},
		onSearch() {
			if (!this.searchText) {
				this.users = [];
				this.searched = false;
				return;
			}
			this.$http({
				url: "/user/search",
				method: "get",
				params: {
					name: this.searchText
				}
			}).then((data) => {
				this.users = data;
				this.searched = true;
			})
		},
		onAddFriend(user) {
			this.$http({
				url: "/friend/add",
				method: "post",
				params: {
					friendId: user.id
				}
			}).then(() => {
				this.$message.success("添加成功，对方已成为您的好友");
				const friend = {
					id: user.id,
					nickName: user.nickName,
					headImage: user.headImageThumb,
					online: user.online,
					deleted: false,
					version: 0
				}
				this.friendStore.addFriend(friend);
				this.$nextTick(() => this.$forceUpdate());
			})
		},
		isFriend(userId) {
			return this.friendStore.isFriend(userId);
		}
	}
}
</script>

<style lang="scss" scoped>
.add-friend {
	.empty-tip {
		text-align: center;
		color: #999;
		font-size: 13px;
		padding: 30px 0;
	}

	.item {
		height: 65px;
		display: flex;
		position: relative;
		padding-left: 15px;
		align-items: center;
		padding-right: 25px;

		.friend-info {
			margin-left: 15px;
			flex: 3;
			display: flex;
			flex-direction: column;
			flex-shrink: 0;
			overflow: hidden;

			.nick-name {
				display: flex;
				flex-direction: row;
				font-weight: 600;
				font-size: 16px;
				line-height: 25px;

				.online-status {
					font-size: 12px;
					font-weight: 600;

					&.online {
						color: #5fb878;
					}
				}
			}

			.user-name {
				display: flex;
				flex-direction: row;
				font-size: 12px;
				line-height: 20px;
			}

		}
	}
}
</style>
